import React from 'react';

// The footer row of a window: an error, or else a warning, on the left, and the buttons (the children) on the right.
export default function DialogFooter({ errorText = null, warningText = null, children = null }) {
  return (
    <div className='EditBoxFooter'>
      <div className='EditBoxFooterInfo'>
        {errorText && (
          <span
            className='EditBoxFooterError'
            role='alert'
          >
            <i className='fa-solid fa-circle-exclamation' /> {errorText}
          </span>
        )}
        {!errorText && warningText && (
          <span className='EditBoxFooterWarning'>
            <i className='fa-solid fa-triangle-exclamation' /> {warningText}
          </span>
        )}
      </div>
      <div className='EditBoxFooterRight'>{children}</div>
    </div>
  );
}
